// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1585":"32db73ea","3792":"32db73ea","5486":"32db73ea","7952":"32db73ea","9671":"32db73ea","9770":"32db73ea"}[chunkId] + ".chunk.css";
};